export default "__VITE_ASSET__BQaa8Yf$__"